export * from './exam-location-table.component';
